import React from "react";

const ProductID = ({ code }: { code?: string | null }) =>
  code ? <span>品番：{code}</span> : null;

export { ProductID };
